import { render, staticRenderFns } from "./writeDialog.vue?vue&type=template&id=837c196a&scoped=true&"
import script from "./writeDialog.vue?vue&type=script&lang=js&"
export * from "./writeDialog.vue?vue&type=script&lang=js&"
import style0 from "./writeDialog.vue?vue&type=style&index=0&id=837c196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "837c196a",
  null
  
)

export default component.exports